// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 24\"> <g> <g> <g> <g> <path d=\"M1.063 12.805L11.848 23.25 14 21.115 4.357 11.75 14 2.385 11.848 0.25 1.063 10.695 0 11.75z\" transform=\"translate(-1120 -123) translate(1100 95) translate(20 28)\"/> </g> </g> </g> </g> </svg> ";
// Exports
module.exports = code;